import { Heading } from '@/components/ui/heading'
import { IconButton } from '@/components/ui/icon-button'
import { AppDrawer } from '@components'
import LayoutHeader from '@components/LayoutHeader';
import { useChannel } from '@features/chat/state';
import { useLocation } from '@solidjs/router'
import { useChannels } from '@stateApp'
import { Menu } from 'lucide-solid'
import { createEffect, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Box, Divider, Grid } from 'styled-system/jsx';
import Channels from './Channels'
import ChannelSetups from './Setups'

export default function Header() {
  const { channelQuery } = useService(useChannel)()
  const [isOpen, setIsOpen] = createSignal(false)
  const location = useLocation()

  createEffect(() => {
    location.pathname
    setIsOpen(false)
  })

  return (
    <Box w='full'>
      <LayoutHeader
        title={channelQuery.data?.name}
        rightContent={<Box display={{
          base: 'none',
          lgDown: 'block',
        }}>
          <AppDrawer
            open={isOpen()}
            onOpenChange={({ open }) => setIsOpen(open)}
            title={channelQuery.data?.name ?? 'Channel'}
            trigger={
              <IconButton
                size="sm"
                variant="plain"
              >
                <Menu />
              </IconButton>
            }
          >
            <Grid w='full'>
              <Heading textStyle='sm'>Chats</Heading>
              <Divider />
              <Channels />
            </Grid>
            <Grid mt='6'>
              <Heading textStyle='sm'>Setups</Heading>
              <Divider />
              <ChannelSetups />
            </Grid>
          </AppDrawer>
        </Box >}
      >
      </LayoutHeader >
    </Box >

  )
}
